import { Box, type SxProps, type Theme } from '@mui/material';
import { Streamdown, type StreamdownProps } from 'streamdown';
import { MARKDOWN_LINK_SAFETY, MARKDOWN_REHYPE_PLUGINS } from './markdown.constants';
import { getMarkdownStyles } from './markdown.styles';
import type { MarkdownColorToken, MarkdownVariant } from './markdown.types';

type MarkdownProps = Pick<StreamdownProps, 'rehypePlugins' | 'remarkPlugins' | 'linkSafety'> & {
  children: string;
  variant?: MarkdownVariant;
  colorToken?: MarkdownColorToken;
  sx?: SxProps<Theme>;
  testId?: string;
};

const Markdown = ({
  children,
  variant = 'body1',
  colorToken = 'text.primary',
  rehypePlugins = MARKDOWN_REHYPE_PLUGINS,
  remarkPlugins,
  linkSafety = MARKDOWN_LINK_SAFETY,
  sx,
  testId,
}: MarkdownProps) => (
  <Box
    test-id={testId}
    sx={[getMarkdownStyles({ variant, colorToken }), ...(Array.isArray(sx) ? sx : [sx])]}
  >
    <Streamdown
      controls={false}
      rehypePlugins={rehypePlugins}
      remarkPlugins={remarkPlugins}
      linkSafety={linkSafety}
    >
      {children}
    </Streamdown>
  </Box>
);

export type { MarkdownProps };
export default Markdown;
